import React from "react"
import { useParams } from "react-router";
import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useMyProfileQuery } from "../../../services/profileService/profile-api";
import { VarianceWorklistRequest } from "../../../services/varianceService/commands";
import { useFindWorklistQuery } from "../../../services/varianceService/variance-api";
import { PermissionChecker } from "../../../services/varianceService/util/PermissionChecker";

type ownProps ={
    title:string;
    queryParam:string;
}

function VarianceDashboardCards(props:ownProps){
    const {center} = useParams();
    const profile = useMyProfileQuery();

    const isAdmin = (): boolean => {
        return PermissionChecker.isVarianceAdmin(profile.data, center) || PermissionChecker.isVarianceQualityTeam(profile.data, center);
    };

    const shouldSkip = !profile.data?.upn || !center;
    const { data } = useFindWorklistQuery(
        profile.data && center
            ? new VarianceWorklistRequest(center, props.queryParam, isAdmin(), profile.data.upn)
            : ({} as any),
        { skip: shouldSkip }
    );
    return <React.Fragment>
        <Card  className='card' sx={{width:'200px', borderRadius:'5pt'}}>
            <CardHeader className='card-header' sx={{textAlign:'center'}} title={<Typography color='#62BCBD' fontWeight={700} variant='body2'>{props.title}</Typography>}/>
                <CardContent>
                    <h2 className="center-align">
                        <Link 
                            style={{color:props.queryParam === 'Denied' ? 'red' : 'green'}}
                            to={"/VarianceWorklist/"+ center + '/' + props.queryParam}>{data?.length ?? 0}
                        </Link>
                    </h2>
            </CardContent>
        </Card>

    </React.Fragment>
}

export {VarianceDashboardCards}

